const DeploymentFallbackUI = () => {
	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: 'rgba(255, 255, 255, 0.98)',
				backdropFilter: 'blur(10px)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				zIndex: 99999,
				fontFamily: 'Inter, sans-serif'
			}}
		>
			<div
				style={{
					maxWidth: '500px',
					padding: '40px',
					textAlign: 'center',
					backgroundColor: 'white',
					borderRadius: '12px',
					boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)'
				}}
			>
				{/* Animated Icon */}
				<div
					style={{
						width: '100px',
						height: '100px',
						margin: '0 auto 24px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
						<path
							fill="#1D020C"
							stroke="#1D020C"
							stroke-width="15"
							transform-origin="center"
							d="m148 84.7 13.8-8-10-17.3-13.8 8a50 50 0 0 0-27.4-15.9v-16h-20v16A50 50 0 0 0 63 67.4l-13.8-8-10 17.3 13.8 8a50 50 0 0 0 0 31.7l-13.8 8 10 17.3 13.8-8a50 50 0 0 0 27.5 15.9v16h20v-16a50 50 0 0 0 27.4-15.9l13.8 8 10-17.3-13.8-8a50 50 0 0 0 0-31.7Zm-47.5 50.8a35 35 0 1 1 0-70 35 35 0 0 1 0 70Z"
						>
							<animateTransform
								type="rotate"
								attributeName="transform"
								calcMode="spline"
								dur="2"
								values="0;120"
								keyTimes="0;1"
								keySplines="0 0 1 1"
								repeatCount="indefinite"
							></animateTransform>
						</path>
					</svg>
				</div>

				{/* Title */}
				<h2
					style={{
						fontSize: '24px',
						fontWeight: '600',
						color: '#1a202c',
						marginBottom: '12px'
					}}
				>
					System is under maintenance.
				</h2>

				{/* Message */}
				<p
					style={{
						fontSize: '16px',
						color: '#718096',
						lineHeight: '1.6',
						marginBottom: '24px'
					}}
				>
					This may take a few minutes. Thank you for your patience.
				</p>

				{/* Refresh Button  */}
				<div className="mt-4">
					<button className="button size36" onClick={() => window.location.reload()}>
						Refresh
					</button>
				</div>
			</div>
		</div>
	);
};

export default DeploymentFallbackUI;
